<div class="w-100 p-12 radius-8 bc-secondary-yellow-100"
     fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="4px">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <ui-kit-svg class="i-16 c-secondary-yellow-900" name="ic_warning"/>
        <div class="t2-semi-bold c-secondary-yellow-900 text-center">
            {{ accentText | translate }}
        </div>
    </div>
    <div class="t2 c-main-gray-900 text-center">
        {{ warningText | translate }}
        <a class="c-main-gray-900 underlined-text" [href]="'mailto:' + SUPPORT_EMAIL">{{ SUPPORT_EMAIL }}</a>
    </div>
</div>
